var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-panel mt-3 pb-3 mb-3 d-flex"},[_c('div',{staticClass:"info"},[_c('router-link',{staticClass:"d-block",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.accountName))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }